import React from 'react';
import EventBrellaLayout from './EventBrellaLayout';

const EventBrellaRevenue = () => (
  <EventBrellaLayout>
    <section className="revenue-section">
      <div className="wrap revenue-flex">
        <div className="receipt">
          <div className="receipt-title">Revenue Per Guest</div>
          <div className="receipt-item"><span className="n">Ticket</span><span className="p">baseline</span></div>
          <div className="receipt-item"><span className="n">Parking, sold in bulk</span><span className="p">+ markup</span></div>
          <div className="receipt-item"><span className="n">Table / VIP upsell</span><span className="p">+ margin</span></div>
          <div className="receipt-item"><span className="n">On-site ordering</span><span className="p">+ tab</span></div>
          <div className="receipt-item"><span className="n">Cross-promoter sales</span><span className="p">+ commission</span></div>
          <div className="receipt-item"><span className="n">Next event, same guest</span><span className="p">+ repeat visit</span></div>
          <div className="receipt-total"><span>Total revenue streams</span><span className="p">6, not 1</span></div>
        </div>
        <div className="revenue-copy">
          <span className="eyebrow">The Opportunity</span>
          <h2 style={{ marginTop: 18 }}>You're only monetizing the front door.</h2>
          <p>
            Food, drinks, VIP, parking, merch, the next event — most of that revenue walks away because there's no system connecting it back to the guest who already paid to be there. One attendee should create more than one line of revenue.
          </p>
          <div className="revenue-list">
            <div className="item">
              <span className="tag">Parking</span>
              <p>Bought in bulk, resold at a markup <strong>the venue keeps</strong> — not a third-party lot.</p>
            </div>
            <div className="item">
              <span className="tag">On-site</span>
              <p>Food and drink ordering runs through the <strong>same guest profile</strong>, no separate POS to reconcile.</p>
            </div>
            <div className="item">
              <span className="tag">Cross-promo</span>
              <p>Promoters on EventBrella can sell into <strong>each other's audiences</strong> and split the revenue.</p>
            </div>
            <div className="item">
              <span className="tag">Loyalty</span>
              <p>A guest who's been recognized four times is far more likely to book a fifth — <strong>without an ad spend</strong>.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </EventBrellaLayout>
);

export default EventBrellaRevenue;
